
import React from 'react';
import { Button } from '@/components/ui/button';
import { Download, Copy, Check } from 'lucide-react';

interface ActionButtonsProps {
  copied: boolean;
  onCopy: () => void;
  onDownload: () => void;
}

const ActionButtons = ({ copied, onCopy, onDownload }: ActionButtonsProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <Button
        onClick={onCopy}
        variant="outline"
        className="w-full border-gray-600 text-gray-300 hover:bg-gray-800 hover:text-white"
      >
        {copied ? <Check className="h-4 w-4 mr-2" /> : <Copy className="h-4 w-4 mr-2" />}
        {copied ? 'Copied!' : 'Copy All Credentials'}
      </Button>
      
      <Button
        onClick={onDownload}
        variant="outline"
        className="w-full border-sports-green text-sports-green hover:bg-sports-green hover:text-black"
      >
        <Download className="h-4 w-4 mr-2" />
        Download as Image
      </Button>
    </div>
  );
};

export default ActionButtons;
